type BlocksInterestInstance = {
  rLeftmin: any;
  rLeftmax: any;
  rRightmin: any;
  rRightmax: any;
  start: any;
  stop: any;
  rrDuration: any;
  AmplitudeTWave: any;
  AmplitudePWave: any;
  distanceT: number;
  distanceP: number;
  indexPeakWave: number;
};

/**
 * Carries one ECG block of interest with its left and right R-peak search windows, block bounds, RR duration and T and P wave amplitudes. Assigns each argument onto the instance and zeroes the derived distanceT, distanceP and indexPeakWave fields.
 *
 * @param lmin - Lower bound of the left R-peak search window.
 * @param lmax - Upper bound of the left R-peak search window.
 * @param rmin - Lower bound of the right R-peak search window.
 * @param rmax - Upper bound of the right R-peak search window.
 * @param st - Start sample index of the block.
 * @param sp - Stop sample index of the block.
 * @param rr - RR interval duration of the block.
 * @param amT - T wave amplitude.
 * @param amP - P wave amplitude.
 * @returns Nothing.
 */
export function BlocksInterest(
  this: BlocksInterestInstance,
  lmin: any,
  lmax: any,
  rmin: any,
  rmax: any,
  st: any,
  sp: any,
  rr: any,
  amT: any,
  amP: any,
) {
  this.rLeftmin = lmin;
  this.rLeftmax = lmax;
  this.rRightmin = rmin;
  this.rRightmax = rmax;

  this.start = st;
  this.stop = sp;

  this.rrDuration = rr;
  this.AmplitudeTWave = amT;
  this.AmplitudePWave = amP;

  this.distanceT = 0;
  this.distanceP = 0;
  this.indexPeakWave = 0;
}

export default { BlocksInterest };
